import { render } from "./formerror.html?vue&type=template&id=0472a9f1&external"
import script from "./FormError.vue?vue&type=script&lang=js"
export * from "./FormError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__